export function delay(durationInSeconds) {
  return new Promise((resolve) => {
    setTimeout(resolve, durationInSeconds * 1000);
  });
}

export function displayDuration(seconds) {
  seconds = Math.trunc(seconds);
  const { minutes, remainingSeconds } = secondsToMinutesAndSeconds(seconds);
  return `${minutes}:${String(remainingSeconds).padStart(2, "0")}`;
}

export function secondsToMinutesAndSeconds(seconds) {
  if (!seconds) return { minutes: 0, remainingSeconds: 0 };

  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return { minutes, remainingSeconds };
}
